import { useTranslation } from "react-i18next";
import { OrderListHeaders } from "../orders/OrderList/OrderListViewHeaders";
import ListActions from "../../yoello-lib/modules/components/UI/ListActions";
import { printersColumns } from "./columns";
import { IListItem } from "./types";
import { useStyles } from "./ui/styles";
import { useDialogRouteStages } from "../dialogRoutes/useDialogRouteStages";
import { useHistory } from "react-router";
import { dialogKeys } from "../../const/URL.const";
import { CustomersList } from "../customersDetails/ui/CustomersList";

interface IPrintersItemContainer {
	printersList: IListItem[];
	isLoading: boolean;
	venueId: string;
	path: string;
}

export function PrintersItemContainer({
	printersList,
	isLoading,
	path
}: IPrintersItemContainer) {
	const history = useHistory();
	const classes = useStyles();
	const { goToNextStep } = useDialogRouteStages(history);

	const { t } = useTranslation();

	function onClickAddNewPrinter() {
		goToNextStep(
			dialogKeys.PRINTER,
			{
				ComponentProps: {},
				dialogTitle: t("printerSettings.form.createFormTitle"),
			}, `${path}/create`, null)
	}

	function onPrinterSelect(printer: IListItem) {
		goToNextStep(
			dialogKeys.PRINTER,
			{
				ComponentProps: { printer },
				dialogTitle: t("printerSettings.form.editFormTitle"),
			}, `${path}/${printer.id}`, null)
	}

	return <>
		<div className={classes.controlers}>
			<ListActions 
				hasCreate={{
					title: t("printerSettings.printerContainer.addNewPrinter"),
					onClick: onClickAddNewPrinter
				}} 
			/>
		</div>
		<div data-component-name="PrintersListContainer">
			<div key={`columnHeaders-customersItems`} className={classes.columnsHeader}>
				{printersColumns.map((column) => <OrderListHeaders {...column} key={`col-${column.key}-${column.label}`} />)}
			</div>
			<CustomersList
				isLoading={isLoading}
				itemList={printersList}
				columns={printersColumns}
				itemSize={80}
				onSelectItem={onPrinterSelect}
				emptyListTitle={t('printerSettings.printersContainer.emptyList')}
				emptyListInfo={t('printerSettings.printersContainer.emptyListInfo')}
				className={classes.customerItem}
			/>
		</div>
	</>
}
